import React, { useEffect } from 'react';

const Latex = (props) => {
    const node = React.createRef();
    const renderMath = () => {
      window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub, node.current]);
    };
    useEffect(() => {
      renderMath();
    }, [props.children]);
    return (
      <div ref={node} {...props}>
        {props.children}
      </div>
    );
};

export default Latex;